import React, { useState } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import i18n from '../../locales';
import MainStyles from '../../styles/MainStyles';
import './index.css'
import TitleBold from '../../components/Text/TitleBold';
import WhiteButton from '../../components/Buttons/WhiteButton';
import InputText from '../../components/FormComponents/InputText';
import BannerHeader from '../../components/Headers/BannerHeader';
import InputCPF from '../../components/FormComponents/InputCPF';

const _checkButtonDisabled = (userData) => {
  return !userData || 
         (userData && 
            (!userData.name || !userData.document || 
            (userData.document && userData.document.length < 10)))
}

const PageUserForm = (props) => {
  const [userData,setUser] = useState(null)

  return (
    <Container fluid="xl">
      <BannerHeader/>
      <Row className='errorpage-row' style={{ ...MainStyles.containerGradient }}>
        <Col>
          <Row>
            <Col sm={{ span: 6, offset: 1 }} md={{ span: 5, offset: 1 }}>
              <TitleBold
                text={i18n.t('user_form.title')}
                size={'medium'}
                color={MainStyles.colors.white}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={{ span: 10, offset: 1 }} md={{ span: 7, offset: 2 }}>
              <Form style={{marginTop: '7%'}}>
                <InputText
                  text={i18n.t('user_form.fields.name')}
                  controlId={"name"}
                  required={true}
                  inputChangeEnd={e =>{
                    if(e.currentTarget.value.length > 2) {
                      setUser({name: e.currentTarget.value, document: userData ? userData.document : null})
                    } else {
                      setUser({name: null, document: userData ? userData.document : null})
                    }
                  }}
                />

                <InputCPF
                  required={true}
                  labelText={i18n.t('user_form.fields.cpf')}
                  setDocument={(docValue) => {
                    setUser({name: userData ? userData.name : null, document: docValue})
                  }}
                />
                
              </Form>
            </Col>
          </Row>
          <Row>
            <Col style={{ textAlign: 'center', paddingTop: '8px' }} xs={{ span: 12 }} sm={{ span: 4, offset: 7 }}>
              <WhiteButton
                text={i18n.t('general.next')}
                isDisabled={_checkButtonDisabled(userData)}
                isRounded={true}
                onClick={() => {
                  // saveUserLocal(userData)
                  props.history.push({
                    pathname: '/vehicle-form',
                    state: { ...userData }
                  })
                }}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  )
}

export default PageUserForm
